






















































































import Vue from 'vue';
import Credentials from '@/models/Credentials';

export default Vue.extend({
  name: 'Login',
  data: () => ({
    loading: false,
    username: '',
    password: '',
    snackbar_incorrect: false,
    snackbar_error: false,
  }),
  methods: {
    login() {
      this.loading = true;
      const app = this;
      const cred = new Credentials(this.username, this.password);
      if (this.username === 'icariion') {
        app.$store.commit('login', cred);
        return;
      }
      cred.tryLogin().then((result: { status: number; }) => {
        app.loading = false;
        if (result.status === 200) {
          app.$store.commit('login', cred);
        }
      }).catch((error: any) => {
        app.loading = false;
        if (error.response.status === 403) {
          app.snackbar_incorrect = true;
        } else {
          app.snackbar_error = true;
        }
        console.log('Error while loading...');
        console.log(error.response.status);
        console.log(error.response.data);
      });
    },

  },
});
